var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-more"},[_c('b-button',{attrs:{"variant":"primary"}},[_vm._v("See full report")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }